/**
 * Dummy data — 대기 예약 (Waitlist)
 * API_DOCS: endpoints.waitlist / endpoints.admin.waitlist
 *
 * WaitlistResponse:
 *   id(int), user_id(int), service_type(string), status(string),
 *   requested_date(date), passengers(int), note(string?), created_at(datetime)
 */

const waitlistItems = [
  { id: 1, user_id: 1, service_type: 'airport', status: 'waiting', requested_date: '2026-03-20', passengers: 2, note: '인천공항 센딩 희망', created_at: '2026-03-01T10:00:00' },
  { id: 2, user_id: 2, service_type: 'golf', status: 'notified', requested_date: '2026-03-22', passengers: 4, note: '블루원 용인 CC 왕복', created_at: '2026-03-02T14:30:00' },
  { id: 3, user_id: 3, service_type: 'tour', status: 'converted', requested_date: '2026-03-25', passengers: 3, note: '남이섬 투어 대기', created_at: '2026-03-03T09:00:00' },
  { id: 4, user_id: 4, service_type: 'hospital', status: 'expired', requested_date: '2026-03-10', passengers: 1, note: '서울아산병원 이동', created_at: '2026-02-28T16:00:00' },
];

function delay(ms) {
  return new Promise((resolve) => setTimeout(resolve, ms));
}

/* ── 서비스 (유저용) ── */

/** GET /api/waitlist */
export const getWaitlist = async (params = {}) => {
  await delay(200);
  return waitlistItems.filter((w) => params.user_id ? w.user_id === Number(params.user_id) : true);
};

/** POST /api/waitlist */
export const createWaitlist = async (data) => {
  await delay(400);
  const item = {
    id: waitlistItems.length + 1,
    user_id: data.user_id || null,
    service_type: data.service_type || null,
    status: 'waiting',
    requested_date: data.requested_date || null,
    passengers: data.passengers || 1,
    note: data.note || null,
    created_at: new Date().toISOString(),
  };
  waitlistItems.push(item);
  return item;
};

/** DELETE /api/waitlist/:id */
export const cancelWaitlist = async (id) => {
  await delay(300);
  const idx = waitlistItems.findIndex((w) => w.id === Number(id));
  if (idx === -1) throw new Error('대기 항목을 찾을 수 없습니다');
  waitlistItems[idx].status = 'cancelled';
  return { message: '대기가 취소되었습니다' };
};

/** POST /api/waitlist/:id/convert */
export const convertWaitlist = async (id) => {
  await delay(400);
  const idx = waitlistItems.findIndex((w) => w.id === Number(id));
  if (idx === -1) throw new Error('대기 항목을 찾을 수 없습니다');
  waitlistItems[idx].status = 'converted';
  return { message: '예약으로 전환되었습니다' };
};

/* ── 관리자 ── */

/** GET /api/admin/waitlist */
export const getAdminWaitlist = async (params = {}) => {
  await delay(300);
  const page = params.page || 1;
  const size = params.size || 20;
  const start = (page - 1) * size;
  return {
    items: waitlistItems.slice(start, start + size),
    total: waitlistItems.length,
    page,
    size,
    pages: Math.ceil(waitlistItems.length / size),
  };
};

/** POST /api/admin/waitlist/:id/notify */
export const notifyAdminWaitlist = async (id) => {
  await delay(400);
  const idx = waitlistItems.findIndex((w) => w.id === Number(id));
  if (idx === -1) throw new Error('대기 항목을 찾을 수 없습니다');
  waitlistItems[idx].status = 'notified';
  return { message: '알림이 발송되었습니다' };
};
